export default __webpack_public_path__ + "static/media/moons.553e7d5f.svg";